import Env from '../../base/env'
import Sms from '../../modules/civilisation/Sms'
import DatesCount from '../../modules/civilisation/DatesCount'
import WineWords from '../../modules/civilisation/WineWords'
import Hammer from 'hammerjs'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const fns = {
  Sms : Sms,
  DatesCount: DatesCount,
  WineWords:WineWords
}

export default class Base
{
  constructor(view = '')
  {
    this.view = view
    this.$sections = this.view.querySelectorAll('.jsBase--slide');
    this.maxWidth = 0;
    // Fns
    this.fnCalc = this.getMaxWidth.bind(this)
  }

  animate()
  {


    gsap.to(this.$sections, {
      x: () => `-${this.maxWidth - window.innerWidth}`,
      ease: "none",
      scrollTrigger: {
        trigger: this.view.querySelector('.jsBase--trigger'),
        pin: true,
        scrub: .7,
        end: () => `+=${this.maxWidth}`,
        invalidateOnRefresh: true
      }
    });

    this.$sections.forEach((sct, i) => {
      ScrollTrigger.create({
        trigger: sct,
        markers:false,
        start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (this.maxWidth / (this.maxWidth - window.innerWidth)),
        end: () => '+=' + sct.offsetWidth * (this.maxWidth / (this.maxWidth - window.innerWidth)),
        toggleClass: {targets: sct, className: "active"},
        onEnter:()=>{
          // if(sct.classList.contains('is-revealed') == false) {
          //   sct.classList.add('is-revealed')
          // }
        }
      });


      // Revealed 55%
      ScrollTrigger.create({
        markers:false,
        start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2.2) * (this.maxWidth / (this.maxWidth - window.innerWidth)),
        // end: ()=>'+=' + sct.offsetWidth * (this.maxWidth / (this.maxWidth - window.innerWidth)),
        onEnter:()=>{
          if(sct.classList.contains('is-revealed') == false) {
            sct.classList.add('is-revealed')
          }
          if(sct.getAttribute('data-init') != null) {
            const fn = sct.getAttribute('data-init')
            const callClass = fns[fn]
            new callClass(sct)
          }
        }
      });
    });
  }

  events()
  {
    ScrollTrigger.addEventListener("refreshInit", this.fnCalc);
  }

  getMaxWidth()
  {
    this.maxWidth = 0;
    this.$sections.forEach((section) => {
      this.maxWidth += section.offsetWidth;
    });
  }


  setup()
  {
    if(Env.mobileCSS == false)
    {
      this.getMaxWidth()
      this.events()
      this.animate()
    }
    // if((Env.tablet == true && Env.orientation == "landscape") || Env.isPad == true) {
    //   this.touchSwipe()
    // }
  }

  touchSwipe()
  {
    this.touchManager = new Hammer.Manager(Env.$master);
    this.swipeEvent = new Hammer.Swipe();
    this.touchManager.add(this.swipeEvent);
    this.touchScrollDirection = {"2":1,"4":-1};
    this.multiplier = 1.5
    this.touchManager.on('swipe', (e)=> {

      const getScrollPos = Env.framework.toolbox.scrollPosition()
      this.valueTouch = e.distance * this.touchScrollDirection[e.offsetDirection]
      window.scrollTo(0,( this.valueTouch * this.multiplier )+getScrollPos.scrollY)
    });
  }
}





